// extracted by mini-css-extract-plugin
export var bottom_cta_btn = "index-module--bottom_cta_btn--c6996";
export var content_btn = "index-module--content_btn--9b09a";
export var content_desc = "index-module--content_desc--37f4b";
export var content_title = "index-module--content_title--99178";
export var content_wrapper = "index-module--content_wrapper--9abc4";
export var cover_wrapper = "index-module--cover_wrapper--f3949";
export var inner = "index-module--inner--2c79a";
export var new_tag = "index-module--new_tag--556d4";
export var wrapper = "index-module--wrapper--cab5f";